import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Logo from '../elements/logo.element';
import FooterLinks from './footer-links';
import { getUTCTimeStamp } from '../../utilities/helper';

const Footer: React.FC = () => {
  return (
    <Box sx={{ bgcolor: '#0d1117', color: '#fff', py: 6 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Box display="flex" alignItems="center" mb={1}>
              <Logo />
              <Typography variant="h6" fontWeight="bold">
                Scrap Auction
              </Typography>
            </Box>
            <Typography variant="body2" color="gray">
              {`India's premier B2B marketplace for scrap trading with transparent auction processes.`}
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <FooterLinks
              title="Quick Links"
              links={[
                { label: 'About Us', href: '/about.html' },
                { label: 'How It Works', href: '/how-it-works.html' },
                { label: 'Steel Info', href: '/steel-information.html' },
                { label: 'Admin Login', href: '/admin/login' },
              ]}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <FooterLinks
              title="Legal"
              links={[
                { label: 'Terms & Conditions', href: '/terms-and-conditions.html' },
                { label: 'Privacy Policy', href: '/privacy-policy.html' },
              ]}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography variant="h6" gutterBottom fontWeight="bold">
              Contact Info
            </Typography>
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <EmailIcon fontSize="small" />
              <Typography variant="body2" color="#ffffff">
                info@scrapauction.in
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <PhoneIcon fontSize="small" />
              <Typography variant="body2" color="#ffffff">
                +91 9996 988 810
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              <LocationOnIcon fontSize="small" />
              <Typography variant="body2" color="#ffffff">
                Gurgaon, Haryana
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Box mt={5} textAlign="center" borderTop="1px solid #2d3748" pt={3}>
          <Typography variant="body2" color="gray">
            © {getUTCTimeStamp().format('YYYY')} Scrap Auction. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
